export default __webpack_public_path__ + "static/hud-15fe5959364242b9d799772432dc0ec0.png";